import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import {
  fadeInLeftOnEnterAnimation,
  fadeInRightOnEnterAnimation,
  fadeOutLeftOnLeaveAnimation,
  fadeOutRightOnLeaveAnimation,
} from 'angular-animations';
import { IconsModule } from '../../icons/icons.module';

@Component({
  selector: 'our-initiative-photo-slides',
  standalone: true,
  imports: [NgClass, IconsModule],
  templateUrl: './photo-slides.component.html',
  styleUrl: './photo-slides.component.scss',
  animations: [
    fadeInLeftOnEnterAnimation(),
    fadeInRightOnEnterAnimation(),
    fadeOutLeftOnLeaveAnimation(),
    fadeOutRightOnLeaveAnimation(),
  ],
})
export class PhotoSlidesComponent {
  selectedIndex: number = 0;

  direction: 'ltr' | 'rtl' = 'ltr';

  atomo_usps: { title: string; description: string; bgImage: string }[] = [
    {
      title: 'Individualized Learning, Powered by AI',
      description:
        'Atomo adapts to every student, teacher, and subject—tailored lessons and instant feedback.',
      bgImage: '../../../../assets/images/our_initiative_1.webp',
    },

    {
      title: 'Education Without Boundaries',
      description:
        'Break barriers with Atomo—bringing quality education to everyone, anywhere, anytime.',
      bgImage: '../../../../assets/images/our_initiative_2.webp',
    },

    {
      title: 'Education That Lasts Forever',
      description:
        'Education is unbreakable, and Atomo makes it last—strong, reliable and built for success.',
      bgImage: '../../../../assets/images/our_initiative_3.webp',
    },

    {
      title: 'Connect, Collaborate, Succeed',
      description:
        'Atomo connects students to collaborate and achieve goals—all in one simple platform.',
      bgImage: '../../../../assets/images/our_initiative_4.webp',
    },
    {
      title: 'Empowering Your Learning Journey',
      description:
        'All-in-one AI-powered classroom—learn, grow, and succeed with Atomo, effortlessly.',
      bgImage: '../../../../assets/images/our_initiative_5.webp',
    },
    {
      title: 'Befriend AI. Enhance learning and accessibility',
      description:
        'AI aids knowledge acquisition and deepens learning, transforming the future of education. Be Future ready with ConCat',
      bgImage: '../../../../assets/images/our_initiative_6.webp',
    },
  ];

  navigateBetweenSlides(dir: 1 | -1) {
    const newIndex = this.selectedIndex + dir;
    if (newIndex >= 0 && newIndex < this.atomo_usps.length) {
      this.direction = dir === 1 ? 'rtl' : 'ltr';
      this.selectedIndex = newIndex;
    }
  }

  returnBg() {
    return `url(${this.atomo_usps[this.selectedIndex].bgImage})`;
  }
}
